import _sfc_main from './editor-text-area.vue.js';
/* empty css                      */
import _export_sfc from '../_virtual/_plugin-vue_export-helper.js';

const EditorTextArea = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-03ab9e25"]]);

export { EditorTextArea as default };
//# sourceMappingURL=editor-text-area.js.map
